var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getTechChildList)?_c('div',[_c('tech-child-header',{attrs:{"page-name":_vm.hdtext}}),_vm._v(" "),_c('tech-child-list',{attrs:{"list":_vm.getTechChildList}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }